<h2 mat-dialog-title>Preview Zone Changes</h2>
<div mat-dialog-content>
  <h3 class="day">{{ data.day }}</h3>
  <div fxLayout="column" fxLayoutGap="10px">
    <div fxLayout="column" fxLayoutGap="10px">
      <span>Zip codes</span>
      @if (data.plusZips.length > 0) {
        <div fxLayout="column wrap" fxLayoutGap="2px">
          @for (zip of data.plusZips; track zip) {
            <span class="zip success">{{ zip }}</span>
          }
        </div>
      }
      @if (data.minusZips.length > 0) {
        <div fxLayout="column wrap" fxLayoutGap="2px">
          @for (zip of data.minusZips; track zip) {
            <span class="zip error">{{ zip }}</span>
          }
        </div>
      }
      @if (data.commonZips.length > 0) {
        <div fxLayout="column wrap" fxLayoutGap="2px">
          @for (zip of data.commonZips; track zip) {
            <span class="zip">{{ zip }}</span>
          }
        </div>
      }
    </div>
    <div fxFlex="1" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
      <div fxFlex="1" class="map-wrapper">
        <div fxLayout="row" fxLayoutAlign="space-between center" style="height: 36px">
          <span>{{ data.schedule?.name }}</span>
          <span class="current">Current zone</span>
        </div>
        <p>{{ data.schedule?.description }}</p>
        <div fxFlex="1" style="height: 180px; border-radius: 12px; overflow: hidden">
          <rspl-map
            style="height: 180px; max-height: 180px"
            [showZoom]="false"
            [showAddressSearch]="false"
            [showZips]="true"
            [selectedZips]="data.schedule.zips"
            [height]="'180px'"
          />
        </div>
      </div>
      <mat-icon>arrow_right_alt</mat-icon>
      <div fxFlex="1" class="map-wrapper" fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="row" fxLayoutAlign="space-between center" style="height: 36px">
          <span>{{ data.zone?.name }}</span>
          @if (data.zone.template_type === 'custom') {
            <button class="primary-btn edit-btn" mat-raised-button (click)="editZone()">
              <div fxLayout="row" fxLayoutGap="5px">
                <span>Edit Zone</span>
                <mat-icon>open_in_new</mat-icon>
              </div>
            </button>
          }
        </div>
        <p>{{ data.zone.description }}</p>
        <div fxFlex="1" style="height: 180px; border-radius: 12px; overflow: hidden">
          <rspl-map
            style="height: 180px; max-height: 180px"
            [showZoom]="false"
            [showAddressSearch]="false"
            [showZips]="true"
            [selectedZips]="data.zone.zips"
            [height]="'180px'"
          />
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end">
  <button mat-button (click)="close()">Back</button>
</div>
